import React from 'react';
import { StepProps } from './index';
import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { CheckCircleFilled } from '@ant-design/icons';
import { Title, Text } from 'src/shared/components/typography';

const Step1: React.FC<StepProps> = ({ onChange, onNext, data }) => {
  const { role } = data;
  const { t } = useTranslation();

  const onRoleSelected = (role: 'Person' | 'EnterpriseAdmin') => {
    onChange({ role });
    setTimeout(() => onNext({ role }), 500);
  };

  // Estas tarjetas son el control real con el que se elige el perfil, no decoracion. Con solo onClick
  // no habia forma de llegar a ellas con el teclado: role/tabIndex/onKeyDown les dan la semantica de
  // boton sin cambiar el marcado ni el aspecto.
  const selectOnKey = (event: React.KeyboardEvent<HTMLDivElement>, value: 'Person' | 'EnterpriseAdmin') => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    onRoleSelected(value);
  };

  return (
    <div id="step1">
      <Title style={{ fontSize: 24 }} level={4}>
        {t('Dinos cuál es tu perfil')}
      </Title>
      <Row style={{ marginTop: 30 }} gutter={[25, 40]} justify="center" align="stretch">
        <Col className="role-selector-container" span={12}>
          {role === 'Person' && <CheckCircleFilled style={{ fontSize: 24 }} className="selected-icon" />}
          <div
            role="button"
            tabIndex={0}
            aria-pressed={role === 'Person'}
            onClick={() => onRoleSelected('Person')}
            onKeyDown={(e) => selectOnKey(e, 'Person')}
            className={`role-selector ${role === 'Person' ? 'selected' : ''}`}
          >
            <Text fontSize={18}>{t('Soy una persona')}</Text>
            <br />
            <Text fontSize={16}>{t('Busco oportunidades laborales o colaboraciones profesionales.')}</Text>
          </div>
        </Col>
        <Col className="role-selector-container" span={12}>
          {role === 'EnterpriseAdmin' && <CheckCircleFilled style={{ fontSize: 24 }} className="selected-icon" />}
          <div
            role="button"
            tabIndex={0}
            aria-pressed={role === 'EnterpriseAdmin'}
            onClick={() => onRoleSelected('EnterpriseAdmin')}
            onKeyDown={(e) => selectOnKey(e, 'EnterpriseAdmin')}
            className={`role-selector ${role === 'EnterpriseAdmin' ? 'selected' : ''}`}
          >
            <Text fontSize={18}>{t('Soy una empresa')}</Text>
            <br />
            <Text fontSize={16}>{t('Quiero acceder al mejor talento para mi empresa.')}</Text>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Step1;
